// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__3OJHc","form":"styles_form__1HuZt","textInput":"styles_textInput__2tJig","grid":"styles_grid__eUNPu","nextButton":"styles_nextButton__3vhAg"};